import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter } from 'react-router-dom';
import { SocketProvider } from './SocketContext';
import { ThemeProvider } from '@mui/material';
import muiTheme from './theme/muiTheme';
import { AgGridProvider } from 'ag-grid-react';
import { AllCommunityModule } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';

const agGridModules = [AllCommunityModule];

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <ThemeProvider theme={muiTheme}>
      <AgGridProvider modules={agGridModules}>
        <Provider store={store}>
          <ToastContainer className={'toast-message'} />
          {/* <SocketProvider> */}
          <BrowserRouter>
            <App />
          </BrowserRouter>
          {/* </SocketProvider> */}
        </Provider>
      </AgGridProvider>
    </ThemeProvider>
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
